export default function ContactSection() {
  return (
    <section id="contact" className="relative py-14 md:py-20 bg-background-950">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm text-primary-400 font-medium tracking-wider uppercase mb-2">Contact</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-50 tracking-wide">联系我们</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">对妖精视频数字颜色系列内容有建议或合作意向？欢迎联系我们</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            <div className="bg-background-800/40 border border-background-700/30 rounded-lg p-5 text-center hover:border-primary-500/20 transition-colors duration-300 cursor-pointer">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400 mx-auto mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-200 mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-600">分享你的数字颜色系列推荐</p>
            </div>
            <div className="bg-background-800/40 border border-background-700/30 rounded-lg p-5 text-center hover:border-primary-500/20 transition-colors duration-300 cursor-pointer">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/15 text-accent-400 mx-auto mb-3">
                <i className="ri-chat-3-line text-xl"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-200 mb-1">意见反馈</h3>
              <p className="text-xs text-foreground-600">帮助我们持续改进观影体验</p>
            </div>
            <div className="bg-background-800/40 border border-background-700/30 rounded-lg p-5 text-center hover:border-primary-500/20 transition-colors duration-300 cursor-pointer">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-500/15 text-secondary-400 mx-auto mb-3">
                <i className="ri-shake-hands-line text-xl"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-200 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-600">频道合作与资源互换洽谈</p>
            </div>
          </div>

          <div className="mt-8 bg-background-800/40 border border-background-700/30 rounded-lg p-5 md:p-6">
            <p className="text-center text-sm text-foreground-500">
              妖精视频为数字颜色系列内容聚合平台，所有内容均来自公开网络资源。如涉及版权或其他问题，请通过上方渠道与我们联系，我们将及时处理。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}